import { useMemo } from 'react';
import {
  syntaxFNMA,
} from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  getAloftPriceJSONPropertyGridField,
  getNumberPropertyGridField,
  suffixField,
} from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridFieldName,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const FeatureGridTransactionSection = (props: PropertyGridSectionProps) => {
  const fields = useMemo(
    () => [
      {
        fieldName: 'editableData.transaction.status' as PropertyGridFieldName,
        label: 'Status',
        options: toOpts(['Active', 'Pending', 'Sold']),
        includeEmptyOption: true,
        toValue: (value?: string) => {
          console.log(value);
          if (!value) return undefined;

          if (value === 'Sold') return 'SettledSale';
          if (value === 'Pending') return 'Contract';

          return value;
        },
        toDisplayValue: (value?: string) => {
          if (!value) return undefined;

          if (value === 'SettledSale') return 'Sold';
          if (value === 'Contract') return 'Pending';

          return value;
        },
      },
      getAloftPriceJSONPropertyGridField('editableData.transaction.price', 'Sale Price'),
      getAloftPriceJSONPropertyGridField('editableData.transaction.originalListPrice', 'Orig. List Price'),
      {
        fieldName: 'editableData.transaction.contractDate' as PropertyGridFieldName,
        label: 'Contract Date',
        toDisplayValue: (isoMonth?: string) => {
          if (!isoMonth) return undefined;
          try {
            const date = syntaxFNMA.isoMonthToAloftDate(isoMonth as syntaxFNMA.IsoMonth);
            return date.format('yyyy-MM');
          } catch {
            return isoMonth;
          }
        },
      },
      {
        fieldName: 'editableData.transaction.saleDate' as PropertyGridFieldName,
        label: 'Sale Date',
        toDisplayValue: (isoMonth?: string) => {
          if (!isoMonth) return undefined;
          try {
            const date = syntaxFNMA.isoMonthToAloftDate(isoMonth as syntaxFNMA.IsoMonth);
            return date.format('yyyy-MM');
          } catch {
            return isoMonth;
          }
        },
      },
      suffixField(
        getNumberPropertyGridField('editableData.transaction.daysOnMarket', 'CDOM'),
        'day',
        'days',
      ),
    ],
    [],
  );

  return (
    <PropertyGridSection
      {...props}
      title="Transaction"
      fields={fields}
    />
  );
};
